/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon_warning_amber': {
    width: 22,
    height: 19,
    viewBox: '0 0 22 19',
    data: '<defs><path pid="0" d="M12 5.99L19.53 19H4.47L12 5.99zM12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z" id="svgicon_icon_warning_amber_a"/></defs><g transform="translate(-1 -2)" _fill="none" fill-rule="evenodd"><mask id="svgicon_icon_warning_amber_b" _fill="#fff"><use xlink:href="#svgicon_icon_warning_amber_a"/></mask><g mask="url(#svgicon_icon_warning_amber_b)" _fill="#898D94"><path pid="1" d="M0 0h24v24H0z"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/components/icons/icon_warning_amber.js